import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'
import 'firebase/performance'
import 'firebase/analytics'
import 'firebase/remote-config'

import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2'

import 'sweetalert2/dist/sweetalert2.min.css'

import LoadingBar from '@/components/LoadingBar.vue'
import LoadingButton from '@/components/LoadingButton.vue'
import Loading from '@/components/Loading.vue'
import Error from '@/components/Error.vue'
import ConstantsMixin from '@/mixins/Constants.js'
import VueSidebarMenu from 'vue-sidebar-menu'

import VueGAPI from 'vue-gapi'
import TrendChart from "vue-trend-chart"
import VueClipboard from 'vue-clipboard2'

// import * as FullStory from '@fullstory/browser'
import VueMeta from 'vue-meta'

import { library, dom } from '@fortawesome/fontawesome-svg-core'

import { faGoogle } from '@fortawesome/free-brands-svg-icons'
import { faAngleDown, faAngleUp, faArrows, faPlayCircle, faSpinner, faSpin, faEdit, faChartBar, faTrashAlt, faCheckCircle, faSyncAlt } from '@fortawesome/pro-regular-svg-icons'
import { faDownload, faPlay, faPause, faLink, faBold, faItalic, faEye, faMousePointer, faExternalLinkSquare, faDatabase, faChevronLeft, faChevronRight, faSearchPlus, faSearchMinus, faTimesCircle, faFlagCheckered } from '@fortawesome/pro-solid-svg-icons'
import { faPlusCircle, faVideo, faTachometer, faEnvelopeOpenText, faUser, faBolt, faCog, faUsers, faUserPlus, faWallet, faToolbox, faQuestionCircle, faPlug, faUserHeadset, faImages } from '@fortawesome/pro-duotone-svg-icons'

import { BootstrapVue } from 'bootstrap-vue'
import _config from '@/config.js'

var __config = _config[process.env.VUE_APP_CONFIG || 'development-local']

// Redirect
if (location.hostname.indexOf('firebaseapp.com') !== -1 || location.hostname.indexOf('web.app') !== -1) {
    location.replace("https://app.doli.ai")
}

Vue.use(firestorePlugin)
Vue.use(BootstrapVue)
Vue.component('Loading', Loading)
Vue.component('Error', Error)
Vue.component('LoadingBar', LoadingBar)
Vue.component('LoadingButton', LoadingButton)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2)
Vue.mixin(ConstantsMixin)
Vue.use(VueSidebarMenu)
Vue.use(VueMeta)
Vue.use(TrendChart)
Vue.use(VueClipboard)

import Analytics from 'analytics'
import hubspot from '@analytics/hubspot'
import fullstory from '@analytics/fullstory'
import segment from '@analytics/segment'
import googleAnalytics from '@analytics/google-analytics'
import mixpanelPlugin from '@analytics/mixpanel'

let plugins = [googleAnalytics({trackingId: __config.firebase_config.measurementId})]
if (__config.fullstory.org_id) {
  plugins.push(fullstory({org: __config.fullstory.org_id}))
}
if (__config.hubspot.site_id) {
  plugins.push(hubspot({portalId: __config.hubspot.site_id}))
}
if (__config.segment.write_key) {
  plugins.push(segment({writeKey: __config.segment.write_key}))
}
if (__config.mixpanel.token) {
  plugins.push(mixpanelPlugin({token: __config.mixpanel.token}))
}

export const analytics = Analytics({
  app: `doli-${process.env.VUE_APP_CONFIG}`,
  version: 100,
  plugins: plugins,
  debug: false
})

library.add(faImages, faUserHeadset, faFlagCheckered, faAngleDown, faAngleUp, faSyncAlt, faPlug, faTimesCircle, faQuestionCircle, faTachometer, faDownload, faGoogle, faArrows, faPlayCircle, faPlusCircle, faSpinner, faEdit, faChartBar, faTrashAlt, faCheckCircle, faChevronLeft, faSearchPlus, faSearchMinus, faChevronRight, faPlay, faPause, faLink, faBold, faItalic, faEye, faMousePointer, faExternalLinkSquare, faDatabase, faEnvelopeOpenText, faVideo, faUser, faBolt, faCog, faUsers, faUserPlus, faWallet, faToolbox)
dom.watch()

// create the 'options' object
//  https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.modify
// see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
const apiConfig = {
  apiKey: __config.gmail.api_key,
  clientId: __config.gmail.client_id,
  scope: 'profile https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.modify https://www.googleapis.com/auth/pubsub',
  ux_mode: "prompt",
  refreshToken: true,
  access_type: 'offline'
}
// Use the plugin and pass along the configuration
Vue.use(VueGAPI, apiConfig)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

import '@/assets/custom.scss'

Vue.config.productionTip = false

// if (__config.fullstory.org_id) {
//   FullStory.init({ orgId: __config.fullstory.org_id})
//   Vue.prototype.$FullStory = FullStory
// }


firebase.initializeApp(__config.firebase_config)

let _remote_config = firebase.remoteConfig()
if (process.env.VUE_APP_CONFIG === 'local' || process.env.VUE_APP_CONFIG === 'development' || process.env.VUE_APP_CONFIG === 'development-local') {
  _remote_config.settings.minimumFetchIntervalMillis = 60 * 1000;
} else {
  _remote_config.settings.minimumFetchIntervalMillis = 60 * 60 * 1000; // once an hour
}

_remote_config.defaultConfig = {
  'require_demo': true,
  'show_sequences': false
}

_remote_config.fetchAndActivate()

export const _firebase = firebase
export const auth = firebase.auth()
export const db = firebase.firestore()
export const storage = firebase.storage()
export const functions = firebase.functions()
export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp
export const FieldValue = firebase.firestore.FieldValue
export const perf = firebase.performance()
export const remote_config = _remote_config

// export const analytics = firebase.analytics()
export const config = _config[process.env.VUE_APP_CONFIG || 'development-local']

if (process.env.VUE_APP_CONFIG === 'local') {
  console.log('** LOCAL **')
  functions.useEmulator('localhost', 5000)
  db.useEmulator('localhost', 5001)
}

if (process.env.VUE_APP_CONFIG === 'development') {
  console.log('** DEVELOPMENT **')
  // functions.useEmulator('localhost', 5000)
}

if (process.env.VUE_APP_CONFIG === 'development-local') {
  console.log('** DEVELOPMENT LOCAL **')
  functions.useEmulator('localhost', 5000)
}

router.beforeEach((to, from, next) => {
  next()
  analytics.page()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
